import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    CircularProgress
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';

import { toast } from 'react-toastify';

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'name', label: 'Package Name', minWidth: 150 },
    { id: 'investmentAmount', label: 'Investment Amount', minWidth: 150 },
    {
        id: 'payoutPercentage',
        label: 'Payout Percentage',
        minWidth: 70
    },
    {
        id: 'bonusPercentage',
        label: 'Bonus Percentage',
        minWidth: 70
    },
    {
        id: 'startDate',
        label: 'Start Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'endDate',
        label: 'End Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'durationDays',
        label: 'Duration Days',
        minWidth: 170
    },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 170
    },
    {
        id: 'createdDate',
        label: 'Created Date',
        minWidth: 170,
        type: 'date'
    },
    {
        id: 'updatedBy',
        label: 'Updated By',
        minWidth: 170
    },
    {
        id: 'updatedDate',
        label: 'Updated Date',
        minWidth: 170,
        type: 'date'
    },

    { id: 'active', label: 'Active', minWidth: 50 }
];

function createData(count, name, payout, start, end, active) {
    return { count, name, payout, start, end, active };
}

const renderTableCell = (value) => {
    if (value === 'active') {
        return <span style={{ padding: '10px', backgroundColor: 'green', color: 'white', borderRadius: '5px' }}>{value}</span>;
    }
    if (value === 'inactive') {
        return <span style={{ padding: '10px', backgroundColor: 'red', color: 'white', borderRadius: '5px' }}>{value}</span>;
    }
    return value;
};

const rows = [
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active'),
    createData('1', 'package name', '3.5%', '5/15/2023', '5/15/2023', 'active')
];

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    minHeight: 500,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [packageDetails, setPackageDetails] = useState({});

    useEffect(() => {
        const fetchPackageDetails = async () => {
            try {
                const res = await axiosInstance.get(`/Package/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (res.status === 200) {
                    setPackageDetails(res.data);
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (open) {
            fetchPackageDetails();
        }
    }, [open]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Package Details
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '300px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Name : <span style={{ fontWeight: 600 }}>{packageDetails.name}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Investment Amount : <span style={{ fontWeight: 600 }}>{packageDetails.investmentAmount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Payout Percentage : <span style={{ fontWeight: 600 }}>{packageDetails.payoutPercentage}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Bonus Percentage : <span style={{ fontWeight: 600 }}>{packageDetails.bonusPercentage}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Start Date : <span style={{ fontWeight: 600 }}>{packageDetails.startDate}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    End Date : <span style={{ fontWeight: 600 }}>{packageDetails.endDate}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Duration Days : <span style={{ fontWeight: 600 }}>{packageDetails.durationDays}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Active : <span style={{ fontWeight: 600 }}>{packageDetails.active ? 'active' : 'inactive'}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{packageDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date : <span style={{ fontWeight: 600 }}>{packageDetails.createdDate}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{packageDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date : <span style={{ fontWeight: 600 }}>{packageDetails.updatedDate}</span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const PackageItemRecords = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [packages, setPackages] = useState([]);

    const [filterPackagesFrom, setFilterPackagesFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterPackagesTo, setFilterPackagesTo] = useState(dayjs());
    const [filterPackagesName, setFilterPackagesName] = useState('');
    const [filterPackagesActiveDate, setFilterPackagesActiveDate] = useState(dayjs(''));
    const [filterPackagesCreatedBy, setFilterPackagesCreatedBy] = useState('');
    const [filterPackagesActive, setFilterPackagesActive] = useState('all');

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    //packages table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {packages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (value === true) {
                                                value = 'active';
                                            }
                                            if (value === false) {
                                                value = 'inactive';
                                            }

                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <>
                                                    <TableCell key={column.id} align={column.align}>
                                                        {renderTableCell(value)}
                                                    </TableCell>
                                                </>
                                            );
                                        })}

                                        {/* <TableCell><button><ManageAccounts /></button></TableCell> */}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <ViewDetailsModal id={row.id} />
                                                <UpdatePackageModal packageDetails={row} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={packages.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //packages table end

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //fetch packages start
    const [fetchPayoutLoading, setFetchPayoutLoading] = useState(false);
    const fetchPackages = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);

        if (!filterPackagesFrom.isValid() || !filterPackagesTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchPackageURL = `/Package/All?createdDateFrom=${filterPackagesFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterPackagesTo.format('YYYY-MM-DD')}`;
        if (filterPackagesName !== '') {
            fetchPackageURL += `&name=${filterPackagesName}`;
        }
        if (filterPackagesActiveDate.isValid()) {
            fetchPackageURL += `&activeDate=${filterPackagesActiveDate.format('YYYY-MM-DD')}`;
        }
        if (filterPackagesCreatedBy !== '') {
            fetchPackageURL += `&createdBy=${filterPackagesCreatedBy}`;
        }
        if (filterPackagesActive !== 'all') {
            if (filterPackagesActive === 'active') {
                fetchPackageURL += `&active=true`;
            }
            if (filterPackagesActive === 'inactive') {
                fetchPackageURL += `&active=false`;
            }
        }
        setFetchPayoutLoading(true);
        try {
            const res = await axiosInstance.get(fetchPackageURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPackages(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchPayoutLoading(false);
        }
    };
    //fetch packages end

    //insert package start
    const InsertPackage = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [insertPackageName, setInsertPackageName] = useState('');
        const [insertPackagePayout, setInsertPackagePayout] = useState(0);
        const [insertPackageBonus, setInsertPackageBonus] = useState(0);
        const [insertPackageStart, setInsertPackageStart] = useState(dayjs().subtract(1, 'days'));
        const [insertPackageEnd, setInsertPackageEnd] = useState(dayjs());
        const [insertPackageActive, setInsertPackageActive] = useState(true);
        const [insertPackageDuration, setInsertPackageDuration] = useState(0);
        const [insertPackageInvestmentAmount, setInsertPackageInvestmentAmount] = useState(0);
        const [insertPackageMinDriverNumber, setInsertPackageMinDriverNumber] = useState(0);
        const [insertPackageMaxDriverNumber, setInsertPackageMaxDriverNumber] = useState(0);
        const [insertPackageMinPayoutPercentage, setInsertPackageMinPayoutPercentage] = useState(0);
        const [insertPackageMaxPayoutPercentage, setInsertPackageMaxPayoutPercentage] = useState(0);
        const [insertPackageMinContributionAmount, setInsertPackageMinContributionAmount] = useState(0);
        const [insertPackageMaxContributionAmount, setInsertPackageMaxContributionAmount] = useState(0);
        const [insertPackageWithdrawalDays, setInsertPackageWithdrawalDays] = useState(0);
        const [insertPackageLoading, setInsertPackageLoading] = useState(false);

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);

        const submitInsertPackage = async () => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);
            // console.log(insertPackageName,insertPackagePayout,insertPackageStart.format("MM-DD-YYYY"),insertPackageEnd.format("MM-DD-YYYY"),insertPackageActive)
            if (
                insertPackageName === '' ||
                // insertPackagePayout === 0 ||
                !insertPackageStart.isValid() ||
                !insertPackageEnd.isValid() ||
                insertPackageDuration === 0
            ) {
                warningAlert('Please fill all inputs.');
                return;
            }
            setInsertPackageLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Package',
                    {
                        name: insertPackageName,
                        payoutPercentage: insertPackagePayout,
                        bonusPercentage: insertPackageBonus,
                        startDate: insertPackageStart.format('YYYY-MM-DD'),
                        endDate: insertPackageEnd.format('YYYY-MM-DD'),
                        active: insertPackageActive,
                        durationDays: insertPackageDuration,
                        investmentAmount: insertPackageInvestmentAmount,
                        minDriverNumber: insertPackageMinDriverNumber,
                        maxDriverNumber: insertPackageMaxDriverNumber,
                        minPayoutPercentage: insertPackageMinPayoutPercentage,
                        maxPayoutPercentage: insertPackageMaxPayoutPercentage,
                        minContributionAmount: insertPackageMinContributionAmount,
                        maxContributionAmount: insertPackageMaxContributionAmount,
                        withdrawalDays: insertPackageWithdrawalDays
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 200) {
                    successAlert('Inserted new package successfully.');
                    fetchPackages();
                } else {
                    errorAlert('Something went wrong');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertPackageLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        // marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Insert Package
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertPackageLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Insert Package
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Package Name :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={insertPackageName}
                                                onChange={(e) => setInsertPackageName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Investment Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageInvestmentAmount}
                                                onChange={(e) => setInsertPackageInvestmentAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackagePayout}
                                                onChange={(e) => setInsertPackagePayout(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Bonus Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageBonus}
                                                onChange={(e) => setInsertPackageBonus(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Start Date :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={insertPackageStart}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setInsertPackageStart(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>End Date :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={insertPackageEnd}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setInsertPackageEnd(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Active :
                                            </Typography>
                                            <Checkbox
                                                checked={insertPackageActive}
                                                onChange={(e) => setInsertPackageActive(e.target.checked)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Duration Days :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageDuration}
                                                onChange={(e) => setInsertPackageDuration(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Driver Number :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMinDriverNumber}
                                                onChange={(e) => setInsertPackageMinDriverNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Driver Number :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMaxDriverNumber}
                                                onChange={(e) => setInsertPackageMaxDriverNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMinPayoutPercentage}
                                                onChange={(e) => setInsertPackageMinPayoutPercentage(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMaxPayoutPercentage}
                                                onChange={(e) => setInsertPackageMaxPayoutPercentage(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Contribution Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMinContributionAmount}
                                                onChange={(e) => setInsertPackageMinContributionAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Contribution Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageMaxContributionAmount}
                                                onChange={(e) => setInsertPackageMaxContributionAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Withdrawal Days :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertPackageWithdrawalDays}
                                                onChange={(e) => setInsertPackageWithdrawalDays(e.target.value)}
                                            />
                                        </Box>
                                    </Grid> */}
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertPackage()}
                                disabled={insertBtnDisabled}
                            >
                                Create
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert package end

    const QuarterProfitDetails = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const token = useSelector(selectCurrentToken);
        const [quarterProfitDetails, setQuarterProfitDetails] = useState({});

        useEffect(() => {
            const fetchQuarterProfitDetails = async () => {
                try {
                    const res = await axiosInstance.get(`/QuarterProfit`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });

                    if (res.status === 200) {
                        setQuarterProfitDetails(res.data);
                        setTotalInvestmentAmount(res.data?.totalInvestmentAmount);
                        setTotalCustomer(res.data?.totalCustomer);
                        setTodayProfit(res.data?.todayProfit);
                        setGrowPercentage(res.data?.growPercentage);
                        setQuarterlyProfit(res.data?.quarterlyProfit);
                        setQuarterNumber(res.data?.quarterNumber);
                        setDateLabel(dayjs(res.data?.dateLabel));
                    } else {
                        errorAlert('Something went wrong.');
                    }
                } catch (error) {
                    console.log(error);
                }
            };
            if (open) {
                fetchQuarterProfitDetails();
            }
        }, [open]);

        const [totalInvestmentAmount, setTotalInvestmentAmount] = useState(quarterProfitDetails?.totalInvestmentAmount);
        const [totalCustomer, setTotalCustomer] = useState(quarterProfitDetails?.totalCustomer);
        const [todayProfit, setTodayProfit] = useState(quarterProfitDetails?.todayProfit);
        const [growPercentage, setGrowPercentage] = useState(quarterProfitDetails?.growPercentage);
        const [quarterlyProfit, setQuarterlyProfit] = useState(quarterProfitDetails?.quarterlyProfit);
        const [quarterNumber, setQuarterNumber] = useState(quarterProfitDetails?.quarterNumber);
        const [dateLabel, setDateLabel] = useState(dayjs(quarterProfitDetails?.dateLabel));

        const [updateQuarterLoading, setUpdateQuarterLoading] = useState(false);

        const [updateQuarterBtnDisabled, setUpdateQuarterBtnDisable] = useState(false);

        const submitUpdateQuarterProfit = async () => {
            if (
                totalInvestmentAmount === null ||
                todayProfit === null ||
                growPercentage === null ||
                quarterlyProfit === null ||
                quarterNumber === null
            ) {
                warningAlert('Please fill all inputs.');
                return;
            }
            setUpdateQuarterBtnDisable(true);
            setUpdateQuarterLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/QuarterProfit',
                    {
                        totalInvestmentAmount: parseFloat(totalInvestmentAmount),
                        todayProfit: parseFloat(todayProfit),
                        growPercentage: parseFloat(growPercentage),
                        quarterlyProfit: parseFloat(quarterlyProfit),
                        quarterNumber: parseInt(quarterNumber),
                        totalCustomer: parseInt(totalCustomer),
                        dateLabel: dateLabel.format('YYYY-MM-DD')
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 200) {
                    successAlert('Updated Profit successfully.');
                    fetchPackages();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateQuarterBtnDisable(false);
                setUpdateQuarterLoading(false);
            }
        };

        return (
            <div>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        // marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Quarter Profit Details
                </Button>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Quarter Profit Details
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>

                        <Box
                            id="modal-modal-description"
                            sx={{
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Date Label :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={dateLabel}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setDateLabel(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Total Investment Amount :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={totalInvestmentAmount}
                                                onChange={(e) => setTotalInvestmentAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Total Customer :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={totalCustomer}
                                                onChange={(e) => setTotalCustomer(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Today Profit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={todayProfit}
                                                onChange={(e) => setTodayProfit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Grow Percentage :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={growPercentage}
                                                onChange={(e) => setGrowPercentage(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Quarterly Profit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={quarterlyProfit}
                                                onChange={(e) => setQuarterlyProfit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Quarter Number :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={quarterNumber}
                                                onChange={(e) => setQuarterNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            display: 'block',
                                            mx: 'auto',
                                            width: '150px',
                                            backgroundColor: deepPurple[500],
                                            marginTop: '50px'
                                        }}
                                        onClick={() => submitUpdateQuarterProfit()}
                                        disabled={updateQuarterBtnDisabled}
                                    >
                                        Update Profit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Modal>
            </div>
        );
    };

    //update package start
    const UpdatePackageModal = ({ packageDetails }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [updatePackageName, setUpdatePackageName] = useState(packageDetails.name);
        const [updatePackagePayout, setUpdatePackagePayout] = useState(packageDetails.payoutPercentage);
        const [updatePackageBonus, setUpdatePackageBonus] = useState(packageDetails.bonusPercentage);
        const [updatePackageStart, setUpdatePackageStart] = useState(dayjs(packageDetails.startDate));
        const [updatePackageEnd, setUpdatePackageEnd] = useState(dayjs(packageDetails.endDate));
        const [updatePackageActive, setUpdatePackageActive] = useState(packageDetails.active);
        const [updatePackageDuration, setUpdatePackageDuration] = useState(packageDetails.durationDays);
        const [updatePackageInvestmentAmount, setUpdatePackageInvestmentAmount] = useState(packageDetails.investmentAmount);
        const [updatePackageMinDriverNumber, setUpdatePackageMinDriverNumber] = useState(packageDetails.minDriverNumber);
        const [updatePackageMaxDriverNumber, setUpdatePackageMaxDriverNumber] = useState(packageDetails.maxDriverNumber);
        const [updatePackageMinPayoutPercentage, setUpdatePackageMinPayoutPercentage] = useState(packageDetails.minPayoutPercentage);
        const [updatePackageMaxPayoutPercentage, setUpdatePackageMaxPayoutPercentage] = useState(packageDetails.maxPayoutPercentage);
        const [updatePackageMinContributionAmount, setUpdatePackageMinContributionAmount] = useState(packageDetails.minContributionAmount);
        const [updatePackageMaxContributionAmount, setUpdatePackageMaxContributionAmount] = useState(packageDetails.maxContributionAmount);
        const [updatePackageWithdrawalDays, setUpdatePackageWithdrawalDays] = useState(packageDetails.withdrawalDays);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updatePackageModal, setUpdatePackageModal] = useState(false);

        const submitUpdatePackage = async () => {
            // console.log(updatePackageStart,updatePackageEnd)
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (
                updatePackageName === '' ||
                // updatePackagePayout === 0 ||
                !updatePackageStart.isValid() ||
                !updatePackageEnd.isValid() ||
                updatePackageDuration === 0
            ) {
                warningAlert('Please fill all inputs.');
                return;
            }
            setUpdatePackageModal(true);
            try {
                const res = await axiosInstance.put(
                    '/Package',
                    {
                        packageID: packageDetails.id,
                        name: updatePackageName,
                        payoutPercentage: updatePackagePayout,
                        bonusPercentage: updatePackageBonus,
                        startDate: updatePackageStart.format('YYYY-MM-DD'),
                        endDate: updatePackageEnd.format('YYYY-MM-DD'),
                        active: updatePackageActive,
                        durationDays: updatePackageDuration,
                        investmentAmount: updatePackageInvestmentAmount,
                        minDriverNumber: updatePackageMinDriverNumber,
                        maxDriverNumber: updatePackageMaxDriverNumber,
                        minPayoutPercentage: updatePackageMinPayoutPercentage,
                        maxPayoutPercentage: updatePackageMaxPayoutPercentage,
                        minContributionAmount: updatePackageMinContributionAmount,
                        maxContributionAmount: updatePackageMaxContributionAmount,
                        withdrawalDays: updatePackageWithdrawalDays
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 200) {
                    successAlert('Updated package successfully.');
                    fetchPackages();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdatePackageModal(false);
            }
        };

        return (
            <div>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updatePackageModal ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Package
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Package Name :
                                            </Typography>
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={updatePackageName}
                                                onChange={(e) => setUpdatePackageName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Investment Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageInvestmentAmount}
                                                onChange={(e) => setUpdatePackageInvestmentAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackagePayout}
                                                onChange={(e) => setUpdatePackagePayout(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Bonus Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageBonus}
                                                onChange={(e) => setUpdatePackageBonus(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Start Date :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={updatePackageStart}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setUpdatePackageStart(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>End Date :
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    value={updatePackageEnd}
                                                    slotProps={{
                                                        textField: {
                                                            error: false
                                                        }
                                                    }}
                                                    onChange={(newValue) => setUpdatePackageEnd(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Active :
                                            </Typography>
                                            <Checkbox
                                                checked={updatePackageActive}
                                                onChange={(e) => setUpdatePackageActive(e.target.checked)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Duration Days :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageDuration}
                                                onChange={(e) => setUpdatePackageDuration(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Driver Number :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMinDriverNumber}
                                                onChange={(e) => setUpdatePackageMinDriverNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Driver Number :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMaxDriverNumber}
                                                onChange={(e) => setUpdatePackageMaxDriverNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMinPayoutPercentage}
                                                onChange={(e) => setUpdatePackageMinPayoutPercentage(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Payout Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMaxPayoutPercentage}
                                                onChange={(e) => setUpdatePackageMaxPayoutPercentage(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Min Contribution Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMinContributionAmount}
                                                onChange={(e) => setUpdatePackageMinContributionAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Max Contribution Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageMaxContributionAmount}
                                                onChange={(e) => setUpdatePackageMaxContributionAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Withdrawal Days :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updatePackageWithdrawalDays}
                                                onChange={(e) => setUpdatePackageWithdrawalDays(e.target.value)}
                                            />
                                        </Box>
                                    </Grid> */}
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdatePackage()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </div>
        );
    };
    //update package end

    useEffect(() => {
        setLoading(false);
        fetchPackages();
    }, []);

    return (
        <Grid container item xs={12}>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                <QuarterProfitDetails />
                <InsertPackage />
            </Box>

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '20px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPackagesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPackagesFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPackagesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPackagesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Name :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterPackagesName}
                            onChange={(e) => setFilterPackagesName(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Active Date :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterPackagesActiveDate}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterPackagesActiveDate(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Created By :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterPackagesCreatedBy}
                            onChange={(e) => setFilterPackagesCreatedBy(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Active :
                        </Typography>
                        <Select value={filterPackagesActive} onChange={(e) => setFilterPackagesActive(e.target.value)}>
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                        </Select>
                    </Box>
                </Grid>
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '50px'
                    }}
                    onClick={() => fetchPackages()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
            </Grid>

            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchPayoutLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default PackageItemRecords;
